class QuickProductFinderDetailModalCtrl {
  constructor(
    loanProfilerService,
    uiService,
    currentUserService,
    configService,
  ) {
    'ngInject';

    this.loanProfilerService = loanProfilerService;
    this.uiService = uiService;
    this.currentUserService = currentUserService;
    this.configService = configService;
  }

  $onInit() {
    this.checkProductLimit();
    this.showTMD = this.configService?.feature?.targetMarketDetermination;
    this.loanProfilerService
      .getProductFullDetails(this.product.ProductID)
      .then((response) => {
        if (!response || !response.data) {
          return;
        }
        this.singleProductDetail = response.data;
      });
  }

  cancel() {
    this.modalInstance.dismiss('cancel');
  }

  checkProductLimit() {
    this.isProductLimit =
      this.productCount >= this.uiService.loanAppProductFinderFavoriteLimit;
  }

  selectLoanStructureProduct(loanStructureData, productData) {
    this.selectLoanProduct(loanStructureData, productData);
    this.cancel();
  }
}

export default QuickProductFinderDetailModalCtrl;
